import React from 'react';
import { ImpContainer, ImpImage, zIndex } from '../..';
import styled from 'styled-components';
const ImageWrapper = styled(ImpContainer) `
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: ${zIndex.badge};
`;
const Container = styled(ImpContainer) `
  position: relative;
  display: table-row;
`;
export default function ImpBadge({ src, children }) {
    return (React.createElement(Container, { dataTestId: "badge-container" },
        children,
        React.createElement(ImageWrapper, { dataTestId: "badge-wrapper" },
            React.createElement(ImpImage, { dataTestId: "badge", height: "24px", width: "24px", src: src, alt: "badge" }))));
}
//# sourceMappingURL=ImpBadge.js.map